import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    standalone: false
})
export class ErrorComponent implements OnInit {

  errorMessage = '';

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const code = params.code || params.c;
      if (code === '400' || code === '404') {
        this.errorMessage = 'We\'re sorry, the data you were looking for could not be found. We recommend trying your request again.';
      } else {
        this.errorMessage = 'We\'re sorry, we had trouble completing your request.';
      }
      this.errorMessage += ' If you continue to experience this problem, please contact a Fidelity representative at 1-800-544-8544.';
    });
  }

}
